<template>
  <div>
    <!-- 导航条 -->
    <top-nav></top-nav>
    <!-- 背景图 -->
    <img
      v-if="bannerList.length !== 0"
      :src="bannerList[0].CompanyName"
      class="img-fluid bg-img"
    />
    <!-- 面包屑 -->
    <div style="background-color: #f5f5f5;">
      <div class="crumbs_wrap type_area">
        <i class="iconfont iconweizhi1"></i>
        <span>您当前所在的位置：</span>
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">首页</li>
          <li class="breadcrumb-item active" aria-current="page">广场动态</li>
        </ol>
      </div>
    </div>
    <!-- 广场动态 -->
    <div class="dynamic_wrap type_area">
      <div class="dynamic_title">
        <div>广场动态</div>
        <div>Square dynamic</div>
      </div>
      <!-- 内容 -->
      <div class="card-group dynamic_item_wrap">
        <div
          class="dynamic_item"
          v-for="item in dynamicList"
          :key="item.Id"
          style="border: none;"
          @click="handleDetailsPage(item.Id)"
        >
          <div style="margin: 0 auto;">
            <img :src="item.CompanyPhone" class="card-img-top" />
            <div class="card-body">
              <div class="card-title item_title">
                {{ item.CompanyName }}
              </div>
              <div class="item_time">{{ item.IssueTime.substr(0, 10) }}</div>

              <div class="card-text item_content" v-html="item.Remarks"></div>

              <div class="item_arrows">→</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item" @click="handlePrevious">
            <a class="page-link" href="javascript:;" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>

          <li
            class="page-item"
            v-for="item in pageCurrentIndex"
            :key="item"
            @click="handlePageActive(item)"
          >
            <a
              :class="[
                'page-link',
                params.pageIndex === item ? 'page_active' : ''
              ]"
              href="javascript:;"
            >
              {{ item }}
            </a>
          </li>

          <li class="page-item" @click="handleNext">
            <a class="page-link" href="javascript:;" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    <!-- 底部 -->
    <bottom-footer></bottom-footer>
  </div>
</template>

<script>
import topNav from '../../components/top-nav'
import bottomFooter from '../../components/bottom-footer'
export default {
  components: { topNav, bottomFooter },

  data() {
    return {
      // 顶部大图数据
      bannerList: [],
      params: {
        SxType: 157,
        pageIndex: 1,
        pageSize: 9
      },
      // 数据
      dynamicList: [],
      // 分页
      pageCurrentIndex: 0
    }
  },

  created() {
    this.params.SxType = this.$route.query.id
    if (
      navigator.userAgent.match(
        /(iPhone|iPod|Android|ios|iOS|iPad|Backerry|WebOS|Symbian|Windows Phone|Phone)/i
      )
    ) {
      this.getBannerList(2)
    } else {
      this.getBannerList(1)
    }
    this.getDynamicList()
  },

  methods: {
    // 获取顶部大图
    async getBannerList(showTo) {
      const { data: res } = await this.$request.post(
        `/SX_Company/GetBannerList?SxType=${this.$route.query.id}&ShowTo=${showTo}`
      )
      this.bannerList = res.data
    },

    // 获取广场动态
    async getDynamicList() {
      const { data: res } = await this.$request.post(
        '/SX_SquareDynamic/GetSquareDynamicList',
        this.params
      )

      this.pageCurrentIndex = Math.ceil(res.data.Count / this.params.pageSize)

      this.dynamicList = res.data.Data
    },

    // 分页切换
    handlePageActive(item) {
      this.params.pageIndex = item
      this.dynamicList = []
      this.getDynamicList()
    },

    // 上一页
    handlePrevious() {
      if (this.pageCurrentIndex !== 1 && this.params.pageIndex !== 1) {
        this.params.pageIndex--
        this.dynamicList = []
        this.getDynamicList()
      }
    },

    // 下一页
    handleNext() {
      if (
        this.pageCurrentIndex !== 1 &&
        this.params.pageIndex < this.pageCurrentIndex
      ) {
        this.params.pageIndex++
        this.dynamicList = []
        this.getDynamicList()
      }
    },

    // 跳转到详情页
    handleDetailsPage(id) {
      const routeURL = this.$router.resolve({
        path: '/square-details',
        query: {
          id: this.$route.query.id,
          detailsId: id
        }
      })

      window.open(routeURL.href, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
// 面包屑
.crumbs_wrap {
  display: flex;
  align-items: center;
  font-size: 14px;
  height: 30px !important;
  color: #666;

  .iconfont {
    color: #c41a26;
    font-size: 20px;
    padding-right: 10px;
  }
}

// 广场动态
.dynamic_item_wrap {
  // display: flex;
  padding: 50px 0;

  .dynamic_item {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    transition: all 0.2s linear;
    width: 390px;
    height: 490px;
    cursor: pointer;
    .card-body {
      padding: 0;
      margin-top: 20px;
    }

    img {
      margin-top: 15px;
      width: 355px;
      height: 193px;
    }

    .item_title {
      width: 355px;
      font-size: 16px;
      color: #333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      padding: 23px 0 11px;
      margin-bottom: 0;
    }

    .item_time {
      width: 355px;
      color: #999;
    }

    .item_content {
      width: 355px;
      height: 75px;
      line-height: 25px;
      margin: 20px 0 30px;
      color: #666;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3; /*截取第三行*/
      overflow: hidden;
    }

    .item_arrows {
      width: 355px;
      text-align: right;
      font-size: 20px;
      color: #858585;
      padding-bottom: 28px;
    }
  }

  .dynamic_item:hover {
    box-shadow: 0px 0px 20px #ccc;
    transition: all 0.2s linear;
    .item_title {
      color: #b92e32;
    }
  }
}

// 通用
.dynamic_wrap {
  padding: 70px 0 65px;

  .dynamic_title {
    text-transform: uppercase;
    text-align: center;
    div:nth-child(1) {
      padding-bottom: 17px;
      font-size: 30px;
      color: #b92e32;
    }

    div:nth-child(2) {
      align-items: center;
      font-size: 16px;
      color: #999;
    }
  }
}

// bootstrap
.breadcrumb {
  padding: 0;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
}

.card {
  background-color: transparent;
}

.pagination {
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  margin: 0;

  .page-item {
    padding: 0 3px 5px;

    .page-link {
      border-radius: 3px;
      color: #666;
    }

    .page-link:focus {
      box-shadow: none;
    }
  }
}

.card-group {
  justify-content: center;
  align-items: center;
}

// pc版心
.type_area {
  width: 1200px;
  height: 100%;
  margin: 0 auto;
}

// 分页切换
.page_active {
  background-color: #b92e32 !important;
  color: #feeb09 !important;
  border: 1px solid #b92e32;
}

@media screen and (max-width: 480px) {
  .type_area {
    width: 375px;
  }

  .iconfont {
    padding: 0 10px;
  }

  // 通用
  .dynamic_wrap {
    padding: 30px 0 25px;
  }

  .dynamic_item_wrap {
    padding: 15px 0;

    .dynamic_item {
      margin-bottom: 0;
      width: auto;
      flex: 1 0 0%;
      width: 374px !important;
      height: auto;

      img {
        width: 328px;
      }

      .card-body {
        padding: 0;
        margin-top: 0;
      }

      .item_title {
        padding: 10px 0;
        width: 325px;
      }

      .item_time {
        width: 325px;
      }

      .item_content {
        margin: 10px 0;
        width: 325px;
      }

      .item_arrows {
        width: 325px;
        padding-bottom: 10px;
      }
    }
  }
}

@media screen and (max-width: 767px) and (min-width: 480px) {
  .type_area {
    width: 640px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1023px) {
  .type_area {
    width: 768px;
  }
}

/* 1024-1200px */
@media screen and (min-width: 1024px) and (max-width: 1199px) {
  .type_area {
    width: 970px;
  }
}

/* 大于1200 px */
@media screen and (min-width: 1200px) {
  .type_area {
    width: 1200px;
  }
}
</style>
